module.exports = __webpack_public_path__ + "static/astor-6f7e648c9b89d3741e68127c47912d02.png";